/** Add integer milliseconds before converting a total, never fractional seconds. */
export const durationMilliseconds = (start: number, end: number): number => Math.max(0, end - start);
export const durationSeconds = (start: number, end: number): number => durationMilliseconds(start,end) / 1000;
